__turbopack_context__.v({
  "code": "IndentContent-module__GXd1qq__code",
  "codeBlock": "IndentContent-module__GXd1qq__codeBlock",
  "container": "IndentContent-module__GXd1qq__container",
  "expanded": "IndentContent-module__GXd1qq__expanded",
  "fileRefs": "IndentContent-module__GXd1qq__fileRefs",
  "frame": "IndentContent-module__GXd1qq__frame",
  "toggle": "IndentContent-module__GXd1qq__toggle",
});
